<form class="wrapper" #formRef="ngForm">
	<bb-page-header [icon]="'language'" [title]="(isNew ? 'CREATE_SUBTITLE' : 'EDIT_SUBTITLE') | translate"
		[inModal]="routeOutlet === 'modal'">
		<bb-status class="bb-status" *ngIf="entity" [(ngModel)]="entity.status" name="status"
			[labelOn]="'ACTIVE' | translate" [labelOff]="'INACTIVE' | translate">
		</bb-status>
	</bb-page-header>

	<div div class="body-column tab-container" [hidden]="!entity">

		<!-- buttons bar -->
		<div class="bar">
			<div [style.display]="'flex'">
				<bb-form-element *ngIf="entity && languageOptions && languageOptions.length > 0" [required]="true">
					<bb-entity-selector [required]="true" [isSubmitted]="form?.submitted" [options]="languageOptions"
						[placeholder]="'LANGUAGE' | translate" [disableClear]="true" name="subtitle-language"
						[(ngModel)]="entity.isocode" (ngModelChange)="onIsocodeChange(entity.isocode)">
					</bb-entity-selector>
				</bb-form-element>
				<label class="upload-button" for="srtFileUploadHidden">
					<bb-button><i class="far fa-up-to-line"></i></bb-button>
				</label>
				<input type="file" hidden (input)="onFileChanged($event)" id="srtFileUploadHidden"
					accept=".srt, .txt" />
			</div>

			<div class="mode-buttons">
				<bb-button (click)="setMode('editor')" [disabled]="!!errorMessage && currentMode === 'text'"
					[join]="'left'" [active]="currentMode === 'editor'">
					<i class="far fa-bars"></i>
				</bb-button>
				<bb-button (click)="setMode('text')" [active]="currentMode === 'text'"
					[join]="'right'">
					<i class="far fa-text"></i>
				</bb-button>
			</div>
		</div>

		<!-- text editor -->
		<div [hidden]="currentMode !== 'text'" class="text-editor">
			<div *ngIf="errorMessage" class="message error">
				<i class="fa fa-circle-exclamation"></i>
				{{ errorMessage }}
			</div>
			<div class="editor-drop-container">
				<div class="file-drop-zone" fileDroppable (onFilesDropped)="onFileDropped($event)">
					<span class="drop-text">{{ 'DROP_FILE_HERE' | translate }}</span>
				</div>
				<bb-form-element [form]="form" class="subtitle-input" [hideLabel]="true" [theme]="'light-v2'">
					<bb-code-editor *ngIf="entity && currentMode === 'text'" name="srt" [(ngModel)]="entity.srt"
						[editorConfig]="{ language: 'srt', lineNumbers: 'on' }" [hideFullscreen]="true"
						[theme]="'light-v2'" [highlightLineNumber]="highlightLineNumber"
						[errorLineNumbers]="errorLineNumbers" (ngModelChange)="onSrtChanged(); onSrtChangedDebounced()">
					</bb-code-editor>
				</bb-form-element>
			</div>
		</div>

		<!-- row based editor -->
		<div [hidden]="currentMode !== 'editor'" class="editor-container">
			<div class="line-editor">
				<bb-subtitle-line-editor #lineEditor [form]="form" [(ngModel)]="srtObject"
					(ngModelChange)="editorObjectChanged()" [duration]="mediaclip?.length" name="subtitle-line-editor">
				</bb-subtitle-line-editor>
			</div>
		</div>
	</div>

	<!-- Video preview on right -->
	<div class="body-column preview-container" *ngIf="entity">
		<!-- Note dynamic assets (hls/mpd) excluded, not supported yet by realtime preview -->
		<bb-player (onPlayerCreated)="onPlayerCreated($event)" [mediaclip]="mediaclip" [autoplay]="true"
			[excludeDynamicAssets]="true"
			[playoutOverrides]="{
			controlBar: 'Show',
			width: '100%',
			responsiveSizing: 'true',
			allowImageSequence:'false',
			aspectRatio: '16:9',
			fullScreen:'Hide',
			languageSelect: 'Show'
		}"></bb-player>

		<div class="controls">
			<div class="controls-row">
				<bb-button class="seek-button" (click)="seekFrame(-1)" [title]="'FRAME_BACK' | translate">
					<i class="fas fa-backward-step"></i>
				</bb-button>
				<bb-button class="seek-button" (click)="seekFrame(1)"
					[disabled]="mediaclip?.length && currentTime >= mediaclip?.length"
					[title]="'FRAME_FORWARD' | translate">
					<i class="fas fa-forward-step"></i>
				</bb-button>
				<strong>{{ "CURRENT_TIME" | translate }}: {{ currentTime | seconds:'withMiliseconds' }}</strong>
			</div>
			<!-- Buttons for using current time, when mode is editor -->
			<div class="controls-row" *ngIf="currentMode === 'editor'">
				<bb-button (mouseenter)="setHoverHighlight('start')" (mouseout)="setHoverHighlight(null)"
					[disabled]="!subtitleService.startId" class="add-chapter"
					(click)="updateSubtitleLineTime(subtitleService.startId, 'start')">
					{{ 'SET_STARTTIME' | translate }}
				</bb-button>
				<bb-button (mouseenter)="setHoverHighlight('end')" (mouseout)="setHoverHighlight(null)"
					[disabled]="!subtitleService.endId" class="add-chapter"
					(click)="updateSubtitleLineTime(subtitleService.endId, 'end')">
					{{ 'SET_ENDTIME' | translate }}
				</bb-button>
				<bb-button [disabled]="subtitleService.inViewId" class="add-chapter"
					(click)="addSubtitle(subtitleService.endId || 0)">
					{{ 'ADD_SUBTITLE_LINE' | translate }}
				</bb-button>
			</div>
		</div>
	</div>
</form>

<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [form]="form"
	[entity]="entity" [hideDelete]="true">
</bb-actions-bar>
